import React from "react";
import { LuWallet, LuTrendingDown, LuUsers } from "react-icons/lu";
import KPICard from "./KPICard";
import LeakageChart from "./LeakageChart";
import LeakageBanner from "./LeakageBanner";

const SectionHeader = ({ title }) => (
  <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "16px", paddingBottom: "8px", borderBottom: "1px solid #F3F4F6" }}>
    {title}
  </div>
);

const Card = ({ title, children }) => (
  <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", padding: "20px" }}>
    <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "16px" }}>{title}</div>
    {children}
  </div>
);

const LeakageTab = ({ metrics: m, currency = "AED" }) => (
  <div style={{ animation: "fadeSlideUp 0.2s ease-out both" }}>
    {/* Summary KPIs */}
    <SectionHeader title="Revenue Leakage Summary" />
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" }}>
      <KPICard animDelay={0}   icon={LuWallet}   label="No-Show Losses"       current={m.lostRevenueNoShows.current}       previous={m.lostRevenueNoShows.previous}       metricKey="lost_revenue_no_shows"      format="currency" currency={currency} invertDelta />
      <KPICard animDelay={50}  icon={LuWallet}   label="Cancellation Losses"  current={m.lostRevenueCancellations.current}  previous={m.lostRevenueCancellations.previous}  metricKey="lost_revenue_cancellations" format="currency" currency={currency} invertDelta />
      <KPICard animDelay={100} icon={LuTrendingDown} label="Cancellation Rate"    current={m.cancellationRatePct.current}       previous={m.cancellationRatePct.previous}       metricKey="cancellation_rate_pct"      format="percent" invertDelta />
      <KPICard animDelay={150} icon={LuTrendingDown} label="No-Show Rate"         current={m.noShowRatePct.current}             previous={m.noShowRatePct.previous}             metricKey="no_show_rate_pct"           format="percent" invertDelta />
      <KPICard animDelay={200} icon={LuUsers}        label="No-Show Count"        current={m.noShowCount.current}               previous={m.noShowCount.previous}               metricKey="no_show_count"              invertDelta />
      <KPICard animDelay={250} icon={LuUsers}        label="Cancelled Count"      current={m.cancelledCount.current}            previous={m.cancelledCount.previous}            metricKey="cancelled_count"            invertDelta />
    </div>

    {/* Chart */}
    <SectionHeader title="Estimated Lost Revenue" />
    <Card title="No-Show & Cancellation Losses — This vs Previous Period">
      <LeakageChart
        noShowCurrent={m.lostRevenueNoShows.current}
        noShowPrevious={m.lostRevenueNoShows.previous}
        cancellationCurrent={m.lostRevenueCancellations.current}
        cancellationPrevious={m.lostRevenueCancellations.previous}
        currency={currency}
      />
    </Card>

    <LeakageBanner
      noShowCurrent={m.lostRevenueNoShows.current}
      noShowPrevious={m.lostRevenueNoShows.previous}
      cancellationCurrent={m.lostRevenueCancellations.current}
      cancellationPrevious={m.lostRevenueCancellations.previous}
      currency={currency}
    />
  </div>
);

export default LeakageTab;
